import React, { useEffect, useReducer, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
// icons
import { MdContactPhone } from "react-icons/md";
import { BsShieldFillPlus } from "react-icons/bs";
import { FaArrowCircleRight } from "react-icons/fa";
import { BiSolidShieldMinus, BiSolidShieldX } from "react-icons/bi";
import { HiShieldCheck, HiShieldExclamation } from "react-icons/hi";

import Skeleton from "react-loading-skeleton";
import { MotionDiv, MessageBox, CountUp, useTitle } from "../components";
import { useGetSummaryQuery } from "../store";

export default function Dashboard() {
  useTitle("Dashboard");
  const { data, isLoading, refetch } = useGetSummaryQuery();

  const navigate = useNavigate();

  useEffect(() => {
    refetch();
  }, [refetch]);

  const Count = ({ title, num, target }) => {
    return isLoading ? (
      <Skeleton count={1} height={100} width={300} baseColor="#afafaf" />
    ) : (
      <div
        // style={{ width: "300px" }}
        className=" shadow col-5 col-lg-3   rounded-3 hover "
        onClick={() => (target ? navigate(`/admin/${target}`) : "")}
      >
        <p className="d-flex flex-column p-3 rounded-3 align-items-center gap-1 border mb-0 m-0 text-secondary">
          <strong className="fs-5">{title}</strong>
          <span className="green fs-4 text-bold">{num}</span>
        </p>
        <p
          className="mb-0 text-bold text-center"
        // style={{ backgroundColor: "#afafaf1a" }}
        >
          Know More
        </p>
      </div>
    );
  };

  return (
    <MotionDiv>
      <h3 className="mb-4 mx-1 fs-4">Dashboard</h3>
      <div className="d-flex flex-wrap col-12  col-lg-12 rounded-3 mx-lg-5 custom-style-dashboard">
        <Count title={"Revenue"} target={"transactions"} num={'$' + data?.revenue} />
        <Count title={"Appraisers"} target={"users"} num={data?.users} />
        <Count title={"Lenders"} target={"lenders"} num={data?.lenders} />
        <Count title={"Jobs"} target={"jobs"} num={data?.jobs} />
        <Count title={"Designations"} target={"designation"} num={data?.designations} />
        <Count title={"Applicants"} target={"applicant"} num={data?.applicants} />
        <Count title={"Total Transactions"} target={"transactions"} num={data?.transactions} />
        <Count title={"Completed Transactions"} target={"transactions"} num={data?.completedTransactionsCount} />
        <Count title={"Pending Transactions"} target={"transactions"} num={data?.pendingTransactionsCount} />
      </div>
    </MotionDiv>
  );
}
